import React from "react";
import { Facebook, Instagram, Linkedin, Mail, Phone } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="contact-section">
          <h3 className="contact-title">Contact Us</h3>
        </div>

        <div className="footer-divider"></div>

        <div className="contact-info">
          <a href="tel:+964750555555" className="contact-item">
            <span className="contact-icon">
              <Phone size={18} aria-hidden="true" />
            </span>
            <span>+964 0750 555 5555</span>
          </a>

          <a href="mailto:arez.khoshnaw@kynetic.krd" className="contact-item">
            <span className="contact-icon">
              <Mail size={18} aria-hidden="true" />
            </span>
            <span>arez.khoshnaw@kynetic.krd</span>
          </a>
        </div>

        <div className="footer-divider"></div>

        <div className="social-links">
          <a
            href="https://facebook.com"
            className="social-link"
            aria-label="Facebook"
          >
            <Facebook size={20} aria-hidden="true" />
            <span>Facebook</span>
          </a>

          <a
            href="https://instagram.com"
            className="social-link"
            aria-label="Instagram"
          >
            <Instagram size={20} aria-hidden="true" />
            <span>Instagram</span>
          </a>

          <a
            href="https://linkedin.com"
            className="social-link"
            aria-label="LinkedIn"
          >
            <Linkedin size={20} aria-hidden="true" />
            <span>LinkedIn</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
